var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Drawer",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        drawer: _vm.drawer,
        size: 870,
        customTitle: true,
        withHeader: true,
        isShowFooter: false,
        "show-close": true,
      },
      on: { close: _vm.close },
    },
    [
      _c("template", { slot: "title" }, [
        _c("span", { staticClass: "title" }, [
          !_vm.isCheck
            ? _c(
                "span",
                {
                  class: { acitve: _vm.acitve === 0 },
                  on: {
                    click: function ($event) {
                      _vm.acitve = 0
                    },
                  },
                },
                [_vm._v("修改发票")]
              )
            : _vm._e(),
          _c(
            "span",
            {
              class: { acitve: _vm.acitve === 1 },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  ;(_vm.acitve = 1), _vm.changeLog(_vm.historyList[0])
                },
              },
            },
            [_vm._v("历史记录")]
          ),
          _c(
            "span",
            {
              class: { acitve: _vm.acitve === 2 },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  ;(_vm.acitve = 2), _vm.changeFeeBackLog()
                },
              },
            },
            [_vm._v("反馈记录")]
          ),
          _vm.rowData.reviewFeedback
            ? _c(
                "span",
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "top-start",
                        width: "auto",
                        trigger: "hover",
                      },
                    },
                    [
                      _c("pre", [_vm._v(_vm._s(_vm.rowData.reviewFeedback))]),
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            background: "rgba(165, 90, 248, 0.1)",
                            color: "#a55af8",
                          },
                          attrs: {
                            slot: "reference",
                            icon: "el-icon-chat-dot-round",
                            size: "medium",
                            round: "",
                          },
                          slot: "reference",
                        },
                        [_vm._v("最新反馈记录")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.rowData.invoiceReviewType
            ? _c("span", { staticClass: "ai-warning" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/bill/red-warning.png"),
                  },
                }),
                _vm._v(
                  " 客户期望税金 " +
                    _vm._s(_vm.rowData.minTax) +
                    "~ " +
                    _vm._s(_vm.rowData.maxTax) +
                    "USD "
                ),
                _c(
                  "span",
                  { staticClass: "ai-btn", on: { click: _vm.showAI } },
                  [_vm._v("AI审单")]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { ref: "lastContent", staticClass: "content" },
        [
          _vm.acitve === 0 || _vm.acitve === 3
            ? _c("InvoiceTable", {
                attrs: {
                  rowData: _vm.rowData,
                  mblType: _vm.mblType,
                  productList: _vm.productList,
                  isShowBack: false,
                  height: _vm.height - 150,
                  controlOverInvoicesId: _vm.controlOverInvoicesId,
                  isCoustomer: _vm.isCoustomer(),
                  isExamine: true,
                  StartValue: _vm.StartValue,
                  EndValue: _vm.EndValue,
                  isCheck: _vm.isCheck,
                },
                on: { ok: _vm.invoiceOk, close: _vm.close },
              })
            : _vm.acitve === 1 && _vm.historyList?.length
            ? _c("div", { staticClass: "history" }, [
                _c(
                  "div",
                  { staticClass: "lists" },
                  _vm._l(_vm.historyList, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "panel",
                        class: { active: item.id === _vm.historyActive },
                        on: {
                          click: function ($event) {
                            return _vm.changeLog(item)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDate(item.createdOn)) +
                            " " +
                            _vm._s(item.editSource !== 1 ? "客户" : "后台") +
                            "修改 "
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "history-contanier" },
                  [
                    _c("InvoiceTable", {
                      attrs: {
                        rowData: _vm.rowData,
                        mblType: _vm.mblType,
                        productList: _vm.historyItems,
                        isShowLock: false,
                        height: _vm.height - 150,
                        isShowBack: false,
                        isOpt: false,
                        controlOverInvoicesId: _vm.controlOverInvoicesId,
                        isCoustomer: _vm.isCoustomer(),
                      },
                      on: { close: _vm.close },
                    }),
                  ],
                  1
                ),
              ])
            : _vm.acitve === 2 && _vm.feeBackList.length
            ? _c("div", { staticClass: "history" }, [
                _c(
                  "div",
                  { staticClass: "lists" },
                  _vm._l(_vm.feeBackList, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "panel",
                        class: { active: item.id === _vm.feeBackItem.id },
                        on: {
                          click: function ($event) {
                            _vm.feeBackItem = item
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDate(item.createdOn)) +
                            " " +
                            _vm._s(item.source !== 1 ? "客户" : "后台") +
                            "反馈 "
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c("div", { staticClass: "feeBack-contanier" }, [
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "45%",
                          "box-sizing": "border-box",
                          "text-align": "left",
                        },
                      },
                      [
                        _c("p", [_vm._v("建议：")]),
                        _c("p", { staticClass: "suggestion" }, [
                          _vm._v(_vm._s(_vm.feeBackItem.message || "--")),
                        ]),
                        _vm.feeBackItem.fileList?.length
                          ? [
                              _c("p", [_vm._v("附件：")]),
                              _c(
                                "div",
                                { staticClass: "fileList" },
                                _vm._l(
                                  _vm.feeBackItem.fileList,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "file" },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.imgUrl(item.fileName),
                                            width: "28",
                                            height: "28",
                                          },
                                        }),
                                        _c("p", [
                                          _vm._v(_vm._s(item.fileName)),
                                        ]),
                                        _c("div", { staticClass: "opt" }, [
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/fdz.png"),
                                              title: "预览",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.review(item)
                                              },
                                            },
                                          }),
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/xz.png"),
                                              title: "下载",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.download(item)
                                              },
                                            },
                                          }),
                                        ]),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm.historyBackfeeBackItem.message
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              width: "45%",
                              "margin-left": "24px",
                              "box-sizing": "border-box",
                              "text-align": "left",
                              color: "red",
                            },
                          },
                          [
                            _c("p", [_vm._v("后台最新反馈记录：")]),
                            _c("p", { staticClass: "suggestion" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.historyBackfeeBackItem.message || "--"
                                )
                              ),
                            ]),
                            _vm.historyBackfeeBackItem.fileList?.length
                              ? [
                                  _c("p", [_vm._v("附件：")]),
                                  _c(
                                    "div",
                                    { staticClass: "fileList" },
                                    _vm._l(
                                      _vm.historyBackfeeBackItem.fileList,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          { key: index, staticClass: "file" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: _vm.imgUrl(item.fileName),
                                                width: "28",
                                                height: "28",
                                              },
                                            }),
                                            _c("p", [
                                              _vm._v(_vm._s(item.fileName)),
                                            ]),
                                            _c("div", { staticClass: "opt" }, [
                                              _c("img", {
                                                attrs: {
                                                  src: require("@/assets/images/fdz.png"),
                                                  title: "预览",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.review(item)
                                                  },
                                                },
                                              }),
                                              _c("img", {
                                                attrs: {
                                                  src: require("@/assets/images/xz.png"),
                                                  title: "下载",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.download(item)
                                                  },
                                                },
                                              }),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                ]),
              ])
            : _c("img", {
                staticClass: "empty",
                attrs: { src: require("@/assets/images/table/empty.webp") },
              }),
        ],
        1
      ),
      _c("AiInvoiceDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible,
          rowData: _vm.rowData,
          productList: _vm.productList,
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible = false
          },
          ok: _vm.invoiceAiOk,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }